import { Component} from '@angular/core';
import { MdSnackBar, MdDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ProductReleaseService } from '../../services/ProductReleaseService';
import { AdalService } from '../../shared/adal.service';
import { ProductsWithPushNotification } from '../../interfaces/PushNotificationHistory';

@Component({
    selector: 'my-page-layout-with-product-release-tab',
    template: require('./product-release-tab.component.html')    
})

export class PageLayoutProductReleaseTabComponent {    
    private sub: Subscription;
    ProductCode: number;
    Title: string;
    Tab: any;
    errorMessage: string;
    ParentProductId: number;
    SelectedTabIndex:number;
    value:number;
    variant:number;
    isValidProductForPushNotification:boolean=false;
    constructor(public dialog: MdDialog,
        private route: ActivatedRoute,
        private router: Router,
        public snackBar: MdSnackBar,        
        private productReleaseService: ProductReleaseService,        
        private adalService: AdalService) {

        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }

        this.sub = this.route.params.subscribe(
            params => {
                this.Title = params['name'];
                this.ProductCode = params['code'];
                this.ParentProductId = params['id'];
                this.value = params['selectedindex'];        
                this.variant= params['variant']; 
                this.getReleaseProductsListByProductCode(this.ProductCode,this.ParentProductId,this.variant);  
                this.isValidProductForPushNotification=this.checkIsValidProductForNotification()              
            }
        );
        
    }   
    checkIsValidProductForNotification() {
        let productCode = this.ProductCode;
        if (productCode in ProductsWithPushNotification) {
          return true;
        }
        return false;
      }
    getNotificationHistory(){
        this.router.navigate(["/app/pglayout/push-notification-history/",this.Title,this.ParentProductId])
      }
    getReleaseProductsListByProductCode(ProductCode: number,ProductId :number,Variant:number) {
        this.productReleaseService.getReleaseProductsListByProductCode(ProductCode,ProductId,Variant).subscribe(
            data => {
                if (!data.IsError && data.DataObject != null) {
                    this.Tab = data.DataObject; 
                    window.setTimeout(()=>{
                        this.SelectedTabIndex = this.value;                        
                     });                  
                }
                else {
                    this.Tab = null;
                }
            },
            error => {
                this.errorMessage = error;
            });
    }   
}
       

      



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/product-release-tab-list/product-release-tab.component.ts